<template>
    <div class="pop-body-ft flex_layout flex_xy_center">
        <p 
            v-show="isiphone"
            class="pf-regular" 
            @click="jumpEvent('苹果支付教程','苹果支付教程')">
            苹果支付教程
        </p>
        <span v-show="isiphone">|</span>
        <p class="pf-regular" @click="jumpEvent('服务协议','会员服务协议')">会员服务协议</p>
        <span>|</span>
        <p class="pf-regular" @click="jumpEvent('自动续费','自动续费协议')">自动续费协议</p>
    </div>
</template>
<script>
    import { jumpToVipPage } from "../js/comp";
    import { ua } from '@kkmh/utils'
    import {doTrackClick} from "../js/track";
    export default {
        name: 'JumpEvent',
            data () {
            return {
                isiphone : ua['iphone'] ? 1 : 0,
            }
        },
        props: {
            j_req:{
                type: Object,
                default () {
                    return {}
                }
            },
        },
        methods:{
            //打开会员相关h5页面
            jumpEvent(pageName, btnname) {
                doTrackClick(btnname, this.j_req);
                jumpToVipPage(pageName)
            },
        },
    }
</script>
<style lang="scss" scoped>
@import "../../../assets/styles/mixins.scss";
.pop-body-ft{
    width: 100%;padding:vws(30px) 0 vws(25px);color: #999;transform: scale(.9);transform-origin: center center;
    span{padding:0 vws(40px);color:#E6E6E6;}
}
</style>



// WEBPACK FOOTER //
// node_modules/@kkmh/pays/src/components/viphalfscreen/comp/JumpEvent.vue